import React, { createContext, useState, useCallback } from 'react';
import useHasMounted from '../../../../utils/hooks/useHasMounted';

export const StepsProgressContext = createContext({});

const StepsProgressProvider = ({ children }) => {
  const isWindowAvailable = useHasMounted();

  const [activeStepIndex, setActiveStepIndex] = useState(1);
  const [allStepsCount, setAllStepsCount] = useState(1);

  const goToPrevProgress = useCallback(() => setActiveStepIndex(activeStepIndex - 1), [activeStepIndex]);
  const goToNextProgress = useCallback(() => setActiveStepIndex(activeStepIndex + 1), [activeStepIndex]);

  if (!isWindowAvailable) return null;

  return (
    <StepsProgressContext.Provider
      value={{ activeStepIndex, allStepsCount, setAllStepsCount, goToPrevProgress, goToNextProgress }}
    >
      {children}
    </StepsProgressContext.Provider>
  );
};

export default StepsProgressProvider;
